import Vertical from "./Vertical/index";
const AppLayouts = {
  Vertical
};
export default AppLayouts;
